













import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import DynamicDocumentNumberFieldTemplate from '../fields/dynamic-document-number-field-template.vue';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';

@Component({
  name: 'dynamic-document-number-brick-template',
  components: {
    DynamicDocumentScreenWidthConfigurationTemplate,
    DynamicDocumentNumberFieldTemplate
  }
})
export default class DynamicDocumentNumberBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldDtoV2 | undefined;
  @Prop({required: true}) context: DisguiseDto.DynamicDocumentContextDto | undefined;

  contextSelectValues: DisguiseDto.SelectDto[] = [];

  created() {
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DynamicDocumentReplacementTokenDto[]>(
        `/dynamicdocuments/v1/documents/contexttypes/${this.context}/replacementtoken/number`
    ).then((response) => {
      const newContextSelectValues: DisguiseDto.SelectDto[] = [{
        value: '',
        text: ''
      }];
      for (const currentReplacementToken of response.data) {
        newContextSelectValues.push({
          text: currentReplacementToken.tokenName,
          value: currentReplacementToken.replacementToken
        });
      }
      this.contextSelectValues = newContextSelectValues;
    });
  }

}
